'use client'
import { styled } from '../../config'

function Svg({ active, ...rest }) {
  if (active) {
    return (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...rest}>
        <circle cx="28" cy="28" r="28" fill="#F4F4F4" />

        <rect
          x="3.15078"
          y="3.15078"
          width="49.7"
          height="49.7"
          rx="24.85"
          stroke="url(#amlhb2l3aW5ydGdvcm5pZGRk)"
          strokeWidth="0.7"
        />
        <circle cx="28" cy="28" r="28" fill="#00B300" />
        <g clipPath="url(#bWphZXZnaHJ0dWlxd3Vp)">
          <circle
            cx="27.9988"
            cy="28.0008"
            r="25.2"
            fill="url(#bmFqa2R3amt1dXV1cnJy)"
          />
        </g>
        <rect
          x="3.14883"
          y="3.15078"
          width="49.7"
          height="49.7"
          rx="24.85"
          stroke="url(#YWtpb2VpaWdpZ2lpaQ==)"
          strokeWidth="0.7"
        />
        <defs>
          <filter
            id="bW1tamhoaGhoYWFqd2Rqamo="
            x="6.30078"
            y="16.1008"
            width="44.0996"
            height="44.8008"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.8" />
            <feGaussianBlur stdDeviation="1.75" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="bWphd3V5cXFxcXFqc3NqcXU="
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="bWphd3V5cXFxcXFqc3NqcXU="
              result="shape"
            />
          </filter>
          <filter
            id="b3Bhd29vb29vd3d1dXU="
            x="33.6004"
            y="17.5004"
            width="14.0004"
            height="14.0004"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.4" />
            <feGaussianBlur stdDeviation="1.4" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="bWphd3V5cXFxcXFqc3NqcXU="
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="bWphd3V5cXFxcXFqc3NqcXU="
              result="shape"
            />
          </filter>
          <pattern
            id="bmFqa2R3amt1dXV1cnJy"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1">
            <use
              xlinkHref="#aWF3dWV1dXlxeXU="
              transform="translate(-0.25) scale(0.00462963)"
            />
          </pattern>
          <linearGradient
            id="bWFqd2V1YXVmaGhoaGhldWV1"
            x1="28.3508"
            y1="16.8008"
            x2="28.3508"
            y2="54.6008"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="white" stopOpacity="1" />
            <stop offset="1" stopColor="white" stopOpacity="1" />
          </linearGradient>
          <linearGradient
            id="amlhb2l3aW5ydGdvcm5pZGRk"
            x1="28.0008"
            y1="2.80078"
            x2="28.0008"
            y2="53.2008"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#DADADA" />
            <stop offset="1" stopColor="#CDCDCD" />
          </linearGradient>
          <linearGradient
            id="YWtpb2VpaWdpZ2lpaQ=="
            x1="27.9988"
            y1="2.80078"
            x2="27.9988"
            y2="53.2008"
            gradientUnits="userSpaceOnUse">
            <stop stopOpacity="1" />
            <stop offset="1" stopOpacity="1" />
          </linearGradient>
          <clipPath id="a2FvcHdvcGVpdGl0aXRpaXRpdA==">
            <rect
              x="2.80078"
              y="2.80078"
              width="50.4"
              height="50.4"
              rx="25.2"
              fill="white"
            />
          </clipPath>
          <clipPath id="bWphZXZnaHJ0dWlxd3Vp">
            <rect
              x="2.79883"
              y="2.80078"
              width="50.4"
              height="50.4"
              rx="25.2"
              fill="white"
            />
          </clipPath>
          <image
            id="aWF3dWV1dXlxeXU="
            width="324"
            height="216"
            xlinkHref="data:image/png;base64,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"
          />
        </defs>
      </svg>
    )
  }
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <circle cx="28" cy="28" r="28" fill="#F4F4F4" />
      <g clipPath="url(#a2FvcHdvcGVpdGl0aXRpaXRpdA==)">
        <circle cx="27.9998" cy="28.0008" r="25.2" fill="#EEEEEE" />
        <g filter="url(#bW1tamhoaGhoYWFqd2Rqamo=)">
          <rect
            x="9.7998"
            y="16.8008"
            width="37.1"
            height="37.8"
            rx="2.1"
            fill="white"
          />
          <rect
            x="10.1498"
            y="17.1508"
            width="36.4"
            height="37.1"
            rx="1.75"
            stroke="url(#bWFqd2V1YXVmaGhoaGhldWV1)"
            strokeWidth="0.7"
          />
        </g>
        <path
          d="M40.5998 29.8204L37.7998 30.8004V25.9004H43.3998V30.8004L40.5998 29.8204Z"
          fill="#F0F0F0"
        />
        <rect
          x="11.9004"
          y="34.3008"
          width="2.8"
          height="2.8"
          rx="0.7"
          fill="#E1E1E1"
        />
        <rect
          x="11.9004"
          y="21.7012"
          width="19.6"
          height="2.8"
          rx="0.7"
          fill="#E1E1E1"
        />
        <rect
          x="11.9004"
          y="25.9004"
          width="13.3"
          height="2.8"
          rx="0.7"
          fill="#E1E1E1"
        />
        <rect
          x="16.7998"
          y="34.3008"
          width="24.5"
          height="2.8"
          rx="0.7"
          fill="#F0F0F0"
        />
        <rect
          x="16.7998"
          y="38.5"
          width="13.3"
          height="2.8"
          rx="0.7"
          fill="#F0F0F0"
        />
        <rect
          x="16.7998"
          y="42.7012"
          width="20.3"
          height="2.8"
          rx="0.7"
          fill="#F0F0F0"
        />
        <rect
          x="11.9004"
          y="38.5"
          width="2.8"
          height="2.8"
          rx="0.7"
          fill="#E1E1E1"
        />
        <rect
          x="11.9004"
          y="42.7012"
          width="2.8"
          height="2.8"
          rx="0.7"
          fill="#E1E1E1"
        />
        <g filter="url(#b3Bhd29vb29vd3d1dXU=)">
          <circle cx="40.6004" cy="23.1004" r="4.2" fill="#F0F0F0" />
        </g>
        <circle cx="40.5998" cy="23.1008" r="2.8" fill="#E1E1E1" />
      </g>
      <rect
        x="3.15078"
        y="3.15078"
        width="49.7"
        height="49.7"
        rx="24.85"
        stroke="url(#amlhb2l3aW5ydGdvcm5pZGRk)"
        strokeWidth="0.7"
      />
      <circle cx="28" cy="28" r="27.5" fill="white" stroke="#F1F1F1" />
      <g clipPath="url(#bWphZXZnaHJ0dWlxd3Vp)">
        <g opacity="1">
          <rect x="3" y="3" width="53" height="17" fill="#009900" />
          <rect x="3" y="36" width="53" height="17" fill="#009900" />
          <rect x="3" y="20" width="53" height="16" fill="white" />
        </g>
      </g>
      <rect
        x="3.14883"
        y="3.15078"
        width="49.7"
        height="49.7"
        rx="24.85"
        stroke="url(#YWtpb2VpaWdpZ2lpaQ==)"
        strokeWidth="0.7"
      />
      <defs>
        <filter
          id="bW1tamhoaGhoYWFqd2Rqamo="
          x="6.2998"
          y="16.1008"
          width="44.0996"
          height="44.8008"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.8" />
          <feGaussianBlur stdDeviation="1.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="bWphd3V5cXFxcXFqc3NqcXU="
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="bWphd3V5cXFxcXFqc3NqcXU="
            result="shape"
          />
        </filter>
        <filter
          id="b3Bhd29vb29vd3d1dXU="
          x="33.6004"
          y="17.5004"
          width="14.0004"
          height="14.0004"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.4" />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="bWphd3V5cXFxcXFqc3NqcXU="
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="bWphd3V5cXFxcXFqc3NqcXU="
            result="shape"
          />
        </filter>
        <linearGradient
          id="bWFqd2V1YXVmaGhoaGhldWV1"
          x1="28.3498"
          y1="16.8008"
          x2="28.3498"
          y2="54.6008"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="1" />
          <stop offset="1" stopColor="white" stopOpacity="1" />
        </linearGradient>
        <linearGradient
          id="amlhb2l3aW5ydGdvcm5pZGRk"
          x1="28.0008"
          y1="2.80078"
          x2="28.0008"
          y2="53.2008"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#DADADA" />
          <stop offset="1" stopColor="#CDCDCD" />
        </linearGradient>
        <linearGradient
          id="YWtpb2VpaWdpZ2lpaQ=="
          x1="27.9988"
          y1="2.80078"
          x2="27.9988"
          y2="53.2008"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="1" />
          <stop offset="1" stopOpacity="1" />
        </linearGradient>
        <clipPath id="a2FvcHdvcGVpdGl0aXRpaXRpdA==">
          <rect
            x="2.80078"
            y="2.80078"
            width="50.4"
            height="50.4"
            rx="25.2"
            fill="white"
          />
        </clipPath>
        <clipPath id="bWphZXZnaHJ0dWlxd3Vp">
          <rect
            x="2.79883"
            y="2.80078"
            width="50.4"
            height="50.4"
            rx="25.2"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const BomberoAndalucia = styled(Svg, {})
